// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> weidner-apartment-homes-theme-belmont -> regency-woods
// Generated: 2026-10-29T23:13:12.962Z
// Counts: 0 design, 13 content, 15 slot group, 5 collection binding, 8 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Layouts</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Be a part of <span data-type=\"field-token\" data-field=\"property_address_city\"></span>'s most exciting luxury apartment community featuring <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Anytime, From Anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>A Home Design For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Space, Your Home, Your Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Choose Your New Home"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.youtube": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.youtube.com/@WeidnerApartmentHomes"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-ee91-7750-946a-69c9de623023.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with sofa, coffee table, and chairs, large window with vertical blinds."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d20bb-7230-74cc-a332-15fc7f12a414.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room and kitchen area with sofa, chairs, coffee table, island, and counter seating."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d022a-1dc5-7452-8232-b51ca4375d9e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen-size bed and decorative pillows, bedside tables with lamps, and artwork on the wall."
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-ee85-7472-ae36-f47e76f6fd35.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A spacious living room and dining area with a kitchen island."
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-f981-7257-9b66-6e34958e7503.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living area with balcony access and an open kitchen with stainless steel appliances."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-3af7-724d-bfc3-915d39bb30c2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Gene Coulon Memorial Beach Park, a lakeside park on Lake Washington near Renton."
      }
    }
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-29a0-72bf-9a0b-7b45e2a02d13.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "The Landing, an outdoor shopping and dining plaza in Renton."
      }
    }
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-5732-7550-a089-88bead3289f4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Riverview Park in Renton, a grassy park with a bridge and riverside trails."
      }
    }
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167248/019d0229-3693-72af-974c-e2aba56e19bb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Topgolf Renton, a high-tech driving range and entertainment venue nearby."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": [
      "ec_febb1b3e85de1cf5c1a18d3e",
      "ec_17dd73a29e8128ffe14e2160",
      "ec_9ad054427e3ef76e0ddddf64",
      "ec_96b81303a609417069f7fb1b",
      "ec_d86948293f10f4cbe22f723c",
      "ec_c5b67160e46afabbe4778064",
      "ec_c6c2dd528dc7a6c47293b4ca",
      "ec_4c62c80df32e2615fea077a4",
      "ec_9fcba2b09b2b5b3ad89bc20e",
      "ec_572e1cc5cb9d532aeb636a04",
      "ec_eb5347afe2c0a27c82bd0a16",
      "ec_44485cfcbf59085df27c8edf"
    ],
    "orderedIds": [
      "ec_1fd48501cd49c81e3de2bf62",
      "ec_91868740da1cab1811f88498",
      "ec_3648953c52a0c41cf4fab40f",
      "ec_42c3b942594d8de9a8135e31",
      "ec_69c7f9fb6011fb9fcc628985",
      "ec_c77dc397c8a89cdf3d39028f",
      "ec_8042ee93257c73ca9fcb8914",
      "ec_5f576d730a2f012fea020177",
      "ec_17dd73a29e8128ffe14e2160",
      "ec_d86948293f10f4cbe22f723c",
      "ec_febb1b3e85de1cf5c1a18d3e",
      "ec_96b81303a609417069f7fb1b",
      "ec_c6c2dd528dc7a6c47293b4ca",
      "ec_9ad054427e3ef76e0ddddf64",
      "ec_c5b67160e46afabbe4778064",
      "ec_572e1cc5cb9d532aeb636a04",
      "ec_9fcba2b09b2b5b3ad89bc20e",
      "ec_4c62c80df32e2615fea077a4",
      "ec_eb5347afe2c0a27c82bd0a16",
      "ec_44485cfcbf59085df27c8edf"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_af5b44525fa4248489a2e771",
      "ec_d5f5327f619757aa1256e8ae",
      "ec_c95a3ab1bfd8b58071e01642",
      "ec_891d0a22ae815ee2d2518010",
      "ec_bd1f53e25aeb18da254b695c",
      "ec_d445f18bd6decb5fd5d51b39",
      "ec_c568d7a309f33804d5f367fc",
      "ec_c1a05c11de3b958f5a45b238",
      "ec_778b69657bcc06ec25fde543",
      "ec_41a31fa1629a858266a9cd9f",
      "ec_7a0f2be6047efc959033cb3c",
      "ec_76c24923c4f0b021e4eec28a"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": [
      "ec_17dd73a29e8128ffe14e2160",
      "ec_febb1b3e85de1cf5c1a18d3e",
      "ec_9ad054427e3ef76e0ddddf64",
      "ec_d86948293f10f4cbe22f723c",
      "ec_41a31fa1629a858266a9cd9f",
      "ec_eb5347afe2c0a27c82bd0a16",
      "ec_9fcba2b09b2b5b3ad89bc20e",
      "ec_c6c2dd528dc7a6c47293b4ca",
      "ec_96b81303a609417069f7fb1b",
      "ec_c1a05c11de3b958f5a45b238",
      "ec_d445f18bd6decb5fd5d51b39",
      "ec_5f576d730a2f012fea020177",
      "ec_c5b67160e46afabbe4778064",
      "ec_c77dc397c8a89cdf3d39028f",
      "ec_f3e646103c2e2c0662a2f3c3"
    ],
    "orderedIds": [
      "ec_f3e646103c2e2c0662a2f3c3",
      "ec_09eefcda2fc289ad91f37212",
      "ec_6111c01e3e499d0839406cdc",
      "ec_de3a19ca99402eb82d2f670f",
      "ec_896c988f9399fc8db4aff290",
      "ec_5cf74f6eb2999e79351e2718",
      "ec_ec3504fa46b1c7eeb68b0f33",
      "ec_44d39c7666c4d51f18c320dc",
      "ec_21cf79ac5b87a0f88e1c99c6",
      "ec_db6fff0c213f8fb5658228e8",
      "ec_c68cb7bb0fed2e331b01fd63",
      "ec_4ea76acf575a78eb64b8689b",
      "ec_778b0c345b9626d732a9d093",
      "ec_d9236ffacf8696770dd3631a",
      "ec_a81fb9c4b8d682d3facb944e",
      "ec_299df65098b0b0d4056ea9f6",
      "ec_01f4bbf74fa447a24d9b844e",
      "ec_6d0e6d4b629079ae8d17ba0c",
      "ec_6c2088b2fa8e474b536d7fde",
      "ec_43216e04f4df63e522dcc9fa",
      "ec_cf5a8819f22d7bc611017d71",
      "ec_f2d23b9d99bbf5eb943f783e",
      "ec_3cbb9c0ced76b5791a594d8a",
      "ec_c7a1f4576a866f7d3eddc1b1",
      "ec_2a6ade204fab829bfc39d766"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "pinnedcallouts.slides": {
    "limit": null,
    "hiddenIds": [
      "ec_f3e646103c2e2c0662a2f3c3"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.images": {
    "limit": null,
    "hiddenIds": [
      "ec_f3e646103c2e2c0662a2f3c3"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
